export const formatDateToUTC = (date: string | Date): string => {
  const dateObj = typeof date === "string" ? new Date(date + "Z") : date;

  if (isNaN(dateObj.getTime())) {
    throw new Error("Invalid date format.");
  }

  const pad = (num: number) => num.toString().padStart(2, "0");

  const day = pad(dateObj.getUTCDate());
  const month = pad(dateObj.getUTCMonth() + 1);
  const year = dateObj.getUTCFullYear();
  const hours = pad(dateObj.getUTCHours());
  const minutes = pad(dateObj.getUTCMinutes());
  const seconds = pad(dateObj.getUTCSeconds());

  return `${day}.${month}.${year} ${hours}:${minutes}:${seconds} UTC`;
};
